import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { ImageViewerComponent } from 'app/image-viewer/image-viewer.component';
import { environment } from 'environments/environment';
import { CodaltComponent } from '../../codalt.component';
import { LocalStorage } from '../../local-storage.class';
import { NewsDocument } from '../../models/news-document.interface';
import { NewsImage } from '../../models/news-image.interface';
import { NewsLikeType } from '../../models/news-like.interface';
import { News } from '../../models/news.interface';
import { ConfirmDialogService } from '../../services/confirm-dialog-service/confirm-dialog.service';
import { NativeFileViewerService } from '../../services/native-file-viewer/native-file-viewer.service';
import { NewsService } from '../../services/news.service';
import { PageTitleService } from '../../services/page-title/page-title.service';

@Component({
    selector: 'app-news-detail',
    templateUrl: './news-detail.component.html',
    styleUrls: ['./news-detail.component.scss'],
    standalone: false,
})
export class NewsDetailComponent extends CodaltComponent implements OnInit {
    loading = false;
    newsItem: News;

    ownLike: NewsLikeType;
    readonly NewsLikeType = NewsLikeType;

    constructor(
        private newsService: NewsService,
        private nativeFileViewer: NativeFileViewerService,
        private location: Location,
        private router: Router,
        private confirmDialogService: ConfirmDialogService,
        private matDialog: MatDialog,
        private confirmDialog: ConfirmDialogService,
        private pageTitleService: PageTitleService
    ) {
        super();
    }

    ngOnInit(): void {
        this.pageTitleService.setTitle('Update');
        this.watchRouteParams(this.RouteParamnames.newsId, ({ newsId }) => this.getNews(newsId));
    }

    delete() {
        this.confirmDialog
            .confirm('Verwijderen', `Weet je zeker dat je dit nieuwsbericht wilt verwijderen?`, 'Ja', 'Nee')
            .then(() =>
                this.subscriptions.add(
                    this.newsService
                        .delete(this.newsItem.id)
                        .subscribe(() => this.router.navigateByUrl(this.Routenames.news))
                )
            );
    }

    openDocument(doc: NewsDocument) {
        const url = `${environment.apiEndpoint}file/thumb?secure=news&path=/${this.newsItem.id}/${doc.path}&access_token=${LocalStorage.getUserToken()}`;
        if (Capacitor.isNativePlatform()) {
            this.nativeFileViewer.openNativePdf(url, doc.path).catch(error => console.error('open failed', error));
        } else {
            this.matDialog.open(ImageViewerComponent, {
                panelClass: 'image-viewer',
                width: '100vw',
                height: '100vh',
                maxWidth: '100vw',
                data: {
                    singlePdf: url,
                },
            });
        }
    }

    openImage(image: NewsImage) {
        this.matDialog.open(ImageViewerComponent, {
            panelClass: 'image-viewer',
            width: '100vw',
            height: '100vh',
            maxWidth: '100vw',
            data: {
                images: this.newsItem.images,
                currentImage: image,
            },
        });
    }

    like(type: NewsLikeType) {
        this.subscriptions.add(
            this.newsService.like(this.newsItem.id, type).subscribe(like => {
                if (like.data) {
                    this.newsItem.likes = [...this.newsItem.likes?.filter(l => l.id !== like.data.id), like.data];
                } else {
                    this.newsItem.likes = [
                        ...this.newsItem.likes?.filter(l => l.user_id !== LocalStorage.getUser().id),
                    ];
                }
                this.ownLike = this.newsItem.likes?.find(a => a.user_id === LocalStorage.getUser().id)?.type;
            })
        );
    }

    private getNews(slug) {
        this.subscriptions.add(
            this.newsService.get(slug).subscribe(
                news => {
                    news.data.images.map(i => {
                        i.image_url = `${environment.apiEndpoint}file/thumb?secure=news&path=/${news.data.id}/${i.path}&access_token=${LocalStorage.getUserToken()}`;
                        return i;
                    });
                    this.newsItem = news.data;
                    this.pageTitleService.setTitle('Update', this.newsItem.title);
                    this.location.replaceState(`${this.Routenames.news}/${news.data.slug}`);
                    this.ownLike = this.newsItem.likes?.find(a => a.user_id === LocalStorage.getUser().id)?.type;
                },
                () => this.router.navigateByUrl(this.Routenames.news)
            )
        );
    }
}
